export const TREAT_CATEGORY_CREATE_REQUEST = 'TREAT_CATEGORY_CREATE_REQUEST'
export const TREAT_CATEGORY_CREATE_SUCCESS = 'TREAT_CATEGORY_CREATE_SUCCESS'
export const TREAT_CATEGORY_CREATE_FAIL = 'TREAT_CATEGORY_CREATE_FAIL'
export const TREAT_CATEGORY__CREATE_RESET = 'TREAT_CATEGORY__CREATE_RESET'


export const LIST_TREAT_REQUEST = 'LIST_TREAT_REQUEST'
export const LIST_TREAT_SUCCESS = 'LIST_TREAT_SUCCESS'
export const LIST_TREAT_FAIL = 'LIST_TREAT_FAIL'
export const LIST_TREAT_RESET = 'LIST_TREAT_RESET'


export const TREAT_CAT_DELETE_REQUEST = 'TREAT_CAT_DELETE_REQUEST'
export const TREAT_CAT_DELETE_SUCCESS = 'TREAT_CAT_DELETE_SUCCESS'
export const TREAT_CAT_DELETE_FAIL = 'TREAT_CAT_DELETE_FAIL'

export const TREAT_UPDATE_CAT_REQUEST = 'TREAT_UPDATE_CAT_REQUEST'
export const TREAT_UPDATE_CAT_SUCCESS = 'TREAT_UPDATE_CAT_SUCCESS'
export const TREAT_UPDATE_CAT_FAIL = ' TREAT_UPDATE_CAT_FAIL'
export const TREAT_UPDATE_CAT_RESET = 'TREAT_UPDATE_CAT_RESET'

export const TREAT_CAT_DETAILS_REQUEST = 'TREAT_CAT_DETAILS_REQUEST '
export const TREAT_CAT_DETAILS_SUCCESS = 'TREAT_CAT_DETAILS_SUCCESS'
export const TREAT_CAT_DETAILS_FAIL = 'TREAT_CAT_DETAILS_FAIL'